import { useEffect } from "react";

const targetIsBody = (e) => e.target.nodeName === "BODY";

/**
 * Calls the callback function when the _Shift_ and _`_ keys are pressed simultaneously.
 * @param {function} callback Callback function
 */
export function useDebug(callback) {
    useEffect(() => {
        window.onkeydown = (e) => {
            if (targetIsBody(e) && e.key === "~")
                callback();
        };
    }, [callback]);
}